import {EitjeButton} from '../components'

export const SubmitButton = props => {
	return <EitjeButton className="submit-button" iconLeft="checked" colorSet="solid" t="submit" {...props} />
}
